// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { AdminAppointmentMethod } from './admin-appointment-method';
import { AdminType } from './admin-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AdminTypeHistory extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  adminTypeHistoryId!: number;
  abn?: string;
  adminAppointmentMethodId?: number;
  adminId!: number;
  adminSuffix?: string;
  adminTypeId!: number;
  appointeeCostsAccountId?: number;
  appointeeFeesAccountId?: number;
  createdBy!: string;
  createdDate!: Date;
  endDate!: Date;
  name?: string;
  startDate!: Date;
  taxBasis?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  admin!: Admin;
  adminAppointmentMethod!: AdminAppointmentMethod;
  adminType!: AdminType;
}

